export const BILLING_ELEMENTS = [
  {
    element: {
      elementDescription: 'Billing App Configuration',
      collectionName: 'billing',
      elementName: 'billing_app_config',
      elementType: 'DEFAULT',
      assetBased: false,
      optional: false,
      categoryType: 'ASSET',
      uniqueTag: true,
      uniqueTagValuePrefix: '',
      uniqueTagValueSuffix: '',
      elementEditDescription: '',
      familyQueryElement: '',
      uniqueTagName: 'config_key',
      query: '',
      uniqueTagStartValue: 0,
      uniqueTagValue: 0,
      sortQuery: '',
      status: 'ACTIVE',
      businessTimeTagsRequired: false,
    },
    tags: [
      {
        tagName: 'config_key',
        emgTagType: 'String',
        tagDescription: 'Config Key',
        required: true,
        hide: false,
        tagOrder: 1,
      },
      {
        tagName: 'currency_code',
        emgTagType: 'String',
        tagDescription: 'Currency Code',
        required: true,
        hide: false,
        tagOrder: 2,
      },
      {
        tagName: 'currency_symbol',
        emgTagType: 'String',
        tagDescription: 'Currency Symbol',
        required: true,
        hide: false,
        tagOrder: 3,
      },
      {
        tagName: 'currency_decimal_places',
        emgTagType: 'Int',
        tagDescription: 'Currency Decimal Places',
        required: true,
        hide: false,
        tagOrder: 4,
      },
      {
        tagName: 'time_of_use',
        emgTagType: 'Boolean',
        tagDescription: 'Time Of Use Billing',
        required: true,
        hide: false,
        tagOrder: 5,
      },
      {
        tagName: 'split_demand_by_tou_period',
        emgTagType: 'Boolean',
        tagDescription: 'Split Demand By TOU Period',
        required: true,
        hide: false,
        tagOrder: 6,
      },
      {
        tagName: 'use_tou_unit_cost',
        emgTagType: 'Boolean',
        tagDescription: 'Use TOU Unit Cost',
        required: true,
        hide: false,
        tagOrder: 7,
      },
      {
        tagName: 'is_active',
        emgTagType: 'Boolean',
        tagDescription: 'Is Active',
        required: true,
        hide: false,
        tagOrder: 8,
      },
    ],
  },
  {
    element: {
      elementName: 'cost_categories',
      elementDescription: 'Cost Categories',
      collectionName: 'billing',
      categoryType: 'ASSET',
      status: 'ACTIVE',
      elementType: 'DEFAULT',
      uniqueTag: false,
      uniqueTagName: 'category_code',
      assetBased: false,
      businessTimeTagsRequired: false,
      optional: false,
    },
    tags: [
      {
        tagName: 'category_code',
        emgTagType: 'String',
        tagDescription: 'Category Code',
        required: true,
        hide: false,
        tagOrder: 1,
      },
      {
        tagName: 'category_name',
        emgTagType: 'String',
        tagDescription: 'Category Name',
        required: true,
        hide: false,
        tagOrder: 2,
      },
      {
        tagName: 'description',
        emgTagType: 'String',
        tagDescription: 'Description',
        required: false,
        hide: false,
        tagOrder: 3,
      },
      {
        tagName: 'calculation_order',
        emgTagType: 'Int',
        tagDescription: 'Calculation Order',
        required: true,
        hide: false,
        tagOrder: 4,
      },
      {
        tagName: 'is_base_charge',
        emgTagType: 'Boolean',
        tagDescription: 'Is Base Charge',
        required: true,
        hide: false,
        tagOrder: 5,
      },
      {
        tagName: 'is_percentage_based',
        emgTagType: 'Boolean',
        tagDescription: 'Is Percentage Based',
        required: false,
        hide: false,
        tagOrder: 6,
      },
      {
        tagName: 'percentage_applies_to',
        emgTagType: 'String',
        tagDescription: 'Percentage Applies To',
        required: false,
        hide: false,
        tagOrder: 7,
      },
      {
        tagName: 'is_active',
        emgTagType: 'Boolean',
        tagDescription: 'Is Active',
        required: true,
        hide: false,
        tagOrder: 8,
      },
    ],
  },
  {
    element: {
      elementName: 'billing_rates',
      elementDescription: 'Billing Rates',
      collectionName: 'billing',
      categoryType: 'ASSET',
      status: 'ACTIVE',
      elementType: 'DEFAULT',
      uniqueTag: false,
      uniqueTagName: 'cost_category',
      assetBased: false,
      businessTimeTagsRequired: false,
      optional: false,
    },
    tags: [
      {
        tagName: 'cost_category',
        emgTagType: 'String',
        tagDescription: 'Cost Category',
        required: true,
        hide: false,
        tagOrder: 1,
      },
      {
        tagName: 'rate',
        emgTagType: 'Double',
        tagDescription: 'Rate',
        required: true,
        hide: false,
        tagOrder: 2,
      },
      {
        tagName: 'rate_type',
        emgTagType: 'String',
        tagDescription: 'Rate Type',
        required: true,
        hide: false,
        tagOrder: 3,
      },
      {
        tagName: 'effective_from',
        emgTagType: 'Int',
        tagDescription: 'Effective From',
        required: true,
        hide: false,
        tagOrder: 4,
      },
      {
        tagName: 'effective_to',
        emgTagType: 'Int',
        tagDescription: 'Effective To',
        required: true,
        hide: false,
        tagOrder: 5,
      },
      {
        tagName: 'created_by',
        emgTagType: 'String',
        tagDescription: 'Created By',
        required: false,
        hide: true,
        tagOrder: 6,
      },
      {
        tagName: 'is_active',
        emgTagType: 'Boolean',
        tagDescription: 'Is Active',
        required: true,
        hide: false,
        tagOrder: 7,
      },
    ],
  },
  {
    element: {
      elementName: 'billing_records',
      elementDescription: 'Billing Records',
      collectionName: 'billing',
      categoryType: 'ASSET',
      status: 'ACTIVE',
      elementType: 'DEFAULT',
      uniqueTag: false,
      assetBased: false,
      businessTimeTagsRequired: true,
      optional: false,
    },
    tags: [
      {
        tagName: 'billing_period_start',
        emgTagType: 'Long',
        tagDescription: 'Billing Period Start',
        required: true,
        hide: false,
        tagOrder: 1,
      },
      {
        tagName: 'billing_period_end',
        emgTagType: 'Long',
        tagDescription: 'Billing Period End',
        required: true,
        hide: false,
        tagOrder: 2,
      },
      {
        tagName: 'total_consumption',
        emgTagType: 'Double',
        tagDescription: 'Total Consumption',
        required: true,
        hide: false,
        tagOrder: 3,
      },
      {
        tagName: 'initial_reading',
        emgTagType: 'Double',
        tagDescription: 'Initial Reading',
        required: true,
        hide: false,
        tagOrder: 4,
      },
      {
        tagName: 'final_reading',
        emgTagType: 'Double',
        tagDescription: 'Final Reading',
        required: true,
        hide: false,
        tagOrder: 5,
      },
      {
        tagName: 'kva_demand',
        emgTagType: 'Double',
        tagDescription: 'KVA Demand',
        required: true,
        hide: false,
        tagOrder: 6,
      },
      {
        tagName: 'charge_breakdown',
        emgTagType: 'String',
        tagDescription: 'Charge Breakdown',
        required: true,
        hide: false,
        tagOrder: 7,
      },
      {
        tagName: 'actual_bill_amount',
        emgTagType: 'Double',
        tagDescription: 'Actual Bill Amount',
        required: true,
        hide: false,
        tagOrder: 8,
      },
      {
        tagName: 'actual_kwh_from_bill',
        emgTagType: 'Double',
        tagDescription: 'Actual kWh From Bill',
        required: false,
        hide: false,
        tagOrder: 9,
      },
      {
        tagName: 'variance',
        emgTagType: 'Double',
        tagDescription: 'Variance',
        required: false,
        hide: false,
        tagOrder: 10,
      },
      {
        tagName: 'rates_used',
        emgTagType: 'String',
        tagDescription: 'Rates Used',
        required: true,
        hide: false,
        tagOrder: 11,
      },
      {
        tagName: 'created_by',
        emgTagType: 'String',
        tagDescription: 'Created By',
        required: false,
        hide: true,
        tagOrder: 12,
      },
      {
        tagName: 'is_active',
        emgTagType: 'Boolean',
        tagDescription: 'Is Active',
        required: true,
        hide: false,
        tagOrder: 13,
      },
    ],
  },
  {
    element: {
      elementName: 'dg_billing_records',
      elementDescription: 'DG Billing Records',
      collectionName: 'billing',
      categoryType: 'ASSET',
      status: 'ACTIVE',
      elementType: 'DEFAULT',
      uniqueTag: false,
      assetBased: false,
      businessTimeTagsRequired: true,
      optional: false,
    },
    tags: [
      {
        tagName: 'billing_period_start',
        emgTagType: 'Long',
        tagDescription: 'Billing Period Start',
        required: true,
        hide: false,
        tagOrder: 1,
      },
      {
        tagName: 'billing_period_end',
        emgTagType: 'Long',
        tagDescription: 'Billing Period End',
        required: true,
        hide: false,
        tagOrder: 2,
      },
      {
        tagName: 'dg_total_consumption',
        emgTagType: 'Double',
        tagDescription: 'DG Total Consumption',
        required: true,
        hide: false,
        tagOrder: 3,
      },
      {
        tagName: 'dg_initial_reading',
        emgTagType: 'Double',
        tagDescription: 'DG Initial Reading',
        required: true,
        hide: false,
        tagOrder: 4,
      },
      {
        tagName: 'dg_final_reading',
        emgTagType: 'Double',
        tagDescription: 'DG Final Reading',
        required: true,
        hide: false,
        tagOrder: 5,
      },
      {
        tagName: 'diesel_consumption',
        emgTagType: 'Double',
        tagDescription: 'Diesel Consumption',
        required: true,
        hide: false,
        tagOrder: 6,
      },
      {
        tagName: 'running_hours',
        emgTagType: 'Double',
        tagDescription: 'Running Hours',
        required: true,
        hide: false,
        tagOrder: 7,
      },
      {
        tagName: 'efficiency_metrics',
        emgTagType: 'String',
        tagDescription: 'Efficiency Metrics',
        required: false,
        hide: false,
        tagOrder: 8,
      },
      {
        tagName: 'notes',
        emgTagType: 'String',
        tagDescription: 'Notes',
        required: false,
        hide: false,
        tagOrder: 9,
      },
      {
        tagName: 'created_by',
        emgTagType: 'String',
        tagDescription: 'Created By',
        required: false,
        hide: true,
        tagOrder: 10,
      },
      {
        tagName: 'is_active',
        emgTagType: 'Boolean',
        tagDescription: 'Is Active',
        required: true,
        hide: false,
        tagOrder: 11,
      },
    ],
  },
];

export const BILLING_ELEMENT_NAMES = BILLING_ELEMENTS.map(({ element }) => element.elementName);
const TAG_SYNC_KEYS = [
  'emgTagType',
  'tagDescription',
  'required',
  'hide',
  'tagOrder',
];

export const getTagSyncPayload = (existingElement, definition) => {
  if (!existingElement || !Array.isArray(existingElement.tags)) {
    return [];
  }

  return definition.tags.reduce((payload, desiredTag) => {
    const existingTag = existingElement.tags.find((tag) => tag.tagName === desiredTag.tagName);

    if (!existingTag || !existingTag.id) {
      return payload;
    }

    const changedFields = TAG_SYNC_KEYS.reduce((fields, key) => {
      if (existingTag[key] !== desiredTag[key]) {
        return {
          ...fields,
          [key]: desiredTag[key],
        };
      }

      return fields;
    }, {});

    if (!Object.keys(changedFields).length) {
      return payload;
    }

    return [
      ...payload,
      {
        tagId: existingTag.id,
        elementId: existingTag.elementId,
        ...changedFields,
      },
    ];
  }, []);
};
